import {FC, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '../auth'
import {
  INVOICES_LIST_PATH,
  shouldAnnounceTaxPublicQr,
  TAX_PUBLIC_QR_INTRO_EVENT,
} from './taxPublicQrIntro'
import '../apps/invoice-management/invoice-print/intro/printPageIntro.scss'

type Feature = {icon: string; title: string; text: string}

const FEATURES: Feature[] = [
  {
    icon: 'la-qrcode',
    title: 'دو QR روی برگه',
    text: 'QR «نسخهٔ برخط» صورتحساب را در پنل باز می‌کند و QR «سامانه مؤدیان» همان صورتحساب را در سایت سازمان.',
  },
  {
    icon: 'la-print',
    title: 'در همهٔ چاپ‌ها',
    text: 'در چاپ A4، چاپ کلاسیک و فایل PDF؛ در نسخهٔ گوشی هم دکمهٔ «مشاهده در سامانه مؤدیان» هست.',
  },
  {
    icon: 'la-check-circle',
    title: 'فقط صورتحساب ثبت‌شده',
    text: 'صورتحسابی که سازمان ثبتش کرده باشد؛ پیش‌نویس، صورتحساب در انتظار نتیجه، پیش‌فاکتور و صورتحساب واردشده از کارپوشه این QR را ندارند.',
  },
  {
    icon: 'la-magic',
    title: 'بدون تنظیم و هزینه',
    text: 'کاری لازم نیست: اولین بار که صورتحساب ثبت‌شده باز یا چاپ می‌شود، لینک آن از سازمان گرفته و برای همیشه نگه داشته می‌شود.',
  },
]

/**
 * The introduction of the organisation's QR on prints, opened only from its item in «امکانات تازه».
 * «فهرست صورتحساب‌ها» opens the sales invoices, where every registered invoice now prints with it.
 */
export const TaxPublicQrIntroGate: FC = () => {
  const {currentUser} = useAuth()
  const navigate = useNavigate()
  const [show, setShow] = useState(false)

  useEffect(() => {
    const open = () => setShow(true)
    window.addEventListener(TAX_PUBLIC_QR_INTRO_EVENT, open)
    return () => window.removeEventListener(TAX_PUBLIC_QR_INTRO_EVENT, open)
  }, [])

  if (!show || !shouldAnnounceTaxPublicQr(currentUser)) return null

  const close = () => setShow(false)
  const invoices = () => {
    setShow(false)
    navigate(INVOICES_LIST_PATH)
  }

  return (
    <Modal
      show
      onHide={close}
      centered
      size='lg'
      fullscreen='sm-down'
      scrollable
      dialogClassName='ppi-modal'
      aria-labelledby='tax-public-qr-intro-title'
    >
      <Modal.Body className='ppi-modal__body'>
        <button type='button' className='ppi-modal__close' onClick={close} aria-label='بستن'>
          <i className='las la-times' aria-hidden='true' />
        </button>

        <div className='ppi-content'>
          <span className='ppi-eyebrow'>
            <i className='las la-star' aria-hidden='true' />
            تازه
          </span>
          <h2 id='tax-public-qr-intro-title' className='ppi-title'>
            QR سامانه مؤدیان روی چاپ
          </h2>
          <p className='ppi-lead'>
            از این پس چاپ هر صورتحساب ثبت‌شده در سامانه مؤدیان، کنار QR خودِ صورتحساب، QR صفحهٔ همان
            صورتحساب در سایت سازمان را هم دارد. خریدار با اسکن آن، صورتحساب ثبت‌شده را بدون ورود به
            کارپوشه در سایت سازمان می‌بیند.
          </p>

          <ul className='ppi-features' aria-label='امکانات QR سامانه مؤدیان'>
            {FEATURES.map((feature) => (
              <li key={feature.title} className='ppi-feature'>
                <span className='ppi-feature__icon' aria-hidden='true'>
                  <i className={`las ${feature.icon}`} />
                </span>
                <span>
                  <strong>{feature.title}</strong>
                  <span className='ppi-feature__text'>{feature.text}</span>
                </span>
              </li>
            ))}
          </ul>

          <section className='ppi-section' aria-labelledby='tax-public-qr-intro-more'>
            <h3 id='tax-public-qr-intro-more' className='ppi-section__title'>
              خروجی گروهی PDF
            </h3>
            <p className='ppi-note'>
              در خروجی گروهی PDF، QR سامانه مؤدیان برای صورتحسابی می‌آید که پیش‌تر دست‌کم یک بار باز
              یا چاپ شده باشد.
            </p>
          </section>
        </div>
      </Modal.Body>
      <Modal.Footer className='ppi-modal__footer'>
        <button type='button' className='btn btn-light' onClick={close}>
          بستن
        </button>
        <button type='button' className='btn btn-primary' onClick={invoices}>
          <i className='las la-file-invoice' aria-hidden='true' />
          فهرست صورتحساب‌ها
        </button>
      </Modal.Footer>
    </Modal>
  )
}
